import { PermissionEnum } from '@api/enum';
import { NavPills } from '@hyperflake/react-ui-library';
import useClientData from 'modules/clients/hooks/useClientData';
import ProjectHierarchyBreadcrumb from 'modules/shared/components/ProjectHierarchyBreadcrumb/ProjectHierarchyBreadcrumb';
import { useTab } from 'modules/shared/components/tabs';
import useAuthPermission from 'modules/shared/hooks/use-auth-permission';
import { ReactNode } from 'react';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

export interface ITabItem {
    content: ReactNode;
    value: string;
}
enum NavTypeEnum {
    PROJECTS = 'projects',
    USERS = 'users',
}
const tabItems: ITabItem[] = [
    {
        content: 'projects',
        value: NavTypeEnum.PROJECTS,
    },
    {
        content: 'Users',
        value: NavTypeEnum.USERS,
    },
];

const ClientLayout = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { clientId } = useParams();
    const { hasPermission } = useAuthPermission();
    // const navItems = [
    //     {
    //         content: 'Client Details',
    //         isActive: pathname.startsWith(`/clients/${clientId}/client-details`),
    //         onClick: () => navigate(`${clientId}/client-details`),
    //         permission: hasPermission(PermissionEnum.CLIENT_READ),
    //     },
    //     {
    //         content: 'Projects',
    //         isActive: pathname.startsWith(`/clients/${clientId}/projects`),
    //         onClick: () => navigate(`${clientId}/projects`),
    //         permission: hasPermission(PermissionEnum.PROJECT_READ),
    //     },
    //     {
    //         content: 'Users',
    //         isActive: pathname.startsWith(`/clients/${clientId}/users`),
    //         onClick: () => navigate(`${clientId}/users`),
    //         permission: hasPermission(PermissionEnum.USER_READ),
    //     },
    // ];
    const navItems = [
        {
            content: 'Client Details',
            href: `/clients/${clientId}/client-details`,
            isActive: pathname.startsWith(`/clients/${clientId}/client-details`),
            permission: hasPermission(PermissionEnum.CLIENT_READ),
        },
        // {
        //     content: 'Client Map',
        //     href: `/clients/${clientId}/client-map`,
        //     isActive: pathname.startsWith(`/clients/${clientId}/client-map`),
        //     permission: hasPermission(PermissionEnum.CLIENT_READ),
        // },
        {
            content: 'Projects',
            href: `/clients/${clientId}/projects`,
            isActive: pathname.startsWith(`/clients/${clientId}/projects`),
            permission: hasPermission(PermissionEnum.PROJECT_READ),
        },
        {
            content: 'Users',
            href: `/clients/${clientId}/users`,
            isActive: pathname.startsWith(`/clients/${clientId}/users`),
            permission: hasPermission(PermissionEnum.USER_READ),
        },
        {
            content: 'Documents',
            href: `/clients/${clientId}/documents`,
            isActive: pathname.startsWith(`/clients/${clientId}/documents`),
            permission: hasPermission(PermissionEnum.DOCUMENT_READ),
        },
    ];

    // const [activeTab, setActiveTab] = useTab(NavTypeEnum.PROJECTS);

    // TODO - fetch client details
    const { client } = useClientData(clientId);

    return (
        <>
            {/* <Sidebar>
                <Sidebar.Content>
                    <div className="flex items-center gap-2">
                        <Avatar src={client?.logoUrl} alt={client?.name} bgColor={client?.preferences?.primaryColor} />
                        <div className="font-semibold">{client?.name}</div>
                    </div>
                </Sidebar.Content>
                <Sidebar.Nav className="pt-0">
                    <div></div>
                    {navItems.map(
                        (row, i) =>
                            row.permission && (
                                <Sidebar.NavItem key={i} isActive={row.isActive} onClick={row.onClick}>
                                    {row.content}
                                </Sidebar.NavItem>
                            )
                    )}
                </Sidebar.Nav>
            </Sidebar> */}
            {/* <AppHeaderWithNav
                headerComponent={<BackButton />}
                title={client?.name}
                navComponent={
                    <NavTab
                        value={activeTab}
                        onChange={(val) => {
                            console.log('value: ' + val);
                            setActiveTab(val);
                            if (val === 'projects') {
                                navigate(`${clientId}/projects`);
                            } else if (val === 'users') {
                                navigate(`${clientId}/users`);
                            }
                        }}
                        items={tabItems}
                    />
                }
            /> */}
            {/* <AppHeaderWithNav
                headerComponent={<BackButton />}
                title={client?.name}
                navComponent={
                    <NavPills
                        items={navItems.map((item) => ({
                            content: item.content,
                            isActive: item.isActive,
                            onClick: () => item.onClick(),
                        }))}
                    />
                }

            /> */}

            <div className="p-3">
                <ProjectHierarchyBreadcrumb
                    appendItems={[
                        {
                            label: 'Client',
                            to: '/',
                        },
                        {
                            label: client?.name,
                            to: `/clients/${client?._id}/client-details`,
                        },
                    ]}
                />

                <NavPills
                    className="mt-4"
                    items={navItems.map((item) => ({
                        content: <Link to={item.href}>{item.content}</Link>,
                        isActive: item.isActive,
                        onClick: () => navigate(item.href),
                    }))}
                />
            </div>

            <Outlet />
        </>
    );
};

export default ClientLayout;
